import axiosInstance from './axiosInstance';

const updateWallet = ({ id, active }) =>
  axiosInstance.patch(`/internal/admin/config/addresses/${id}`, { active });

export default updateWallet;
